import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
let serverUrl = getSecret('SERVER_URL');

export const getters = {
    getTypeActorFields() {
        return {
            model: 'type_actor',
            label: 'Types Actor',
            fields: [
                { key: 'name', label: 'Name', type: 'text', sortable: true, required: true },
                { key: 'id_license', label: 'id_license', type: 'number', sortable: true, required: true },
                { key: 'status', label: 'status', type: 'boolean', sortable: true, required: true },
            ]
        }
    },
}

export const actions = {
    async fetchActors(context, query = '') {
        return axios
            .get(`${serverUrl}/api/v1/actors/actor/${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async fetchOptionsActors(context, query = '') {
        return axios
            .options(`${serverUrl}/api/v1/actors/actor/${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async createActors(context, payload) {
        return axios
            .post(`${serverUrl}/api/v1/actors/actor/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async updateActors(context, payload) {
        return axios
            .put(`${serverUrl}/api/v1/actors/actor/${payload.id}/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async deleteActors(context, id) {
        return axios
            .delete(`${serverUrl}/api/v1/actors/actor/${id}/`)
            .then((response) => {
                return response.data;
            })
    },
    async fetchActorsGroup(context, query = '') {
        return axios
            .get(`${serverUrl}/api/v1/actors/group/${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async fetchOptionsActorsGroup(context, query = '') {
        return axios
            .options(`${serverUrl}/api/v1/actors/group/${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async createActorsGroup(context, payload) {
        return axios
            .post(`${serverUrl}/api/v1/actors/group/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async updateActorsGroup(context, payload) {
        return axios
            .put(`${serverUrl}/api/v1/actors/group/${payload.id}/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async deleteActorsGroup(context, id) {
        return axios
            .delete(`${serverUrl}/api/v1/actors/group/${id}/`)
            .then((response) => {
                return response.data;
            })
    },

    async fetchPlates(context, query = '') {
        return axios
            .get(`${serverUrl}/api/v1/actors/plate/${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async createPlates(context, payload) {
        return axios
            .post(`${serverUrl}/api/v1/actors/plate/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async updatePlates(context, payload) {
        return axios
            .put(`${serverUrl}/api/v1/actors/plate/${payload.id}/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async deletePlates(context, id) {
        return axios
            .delete(`${serverUrl}/api/v1/actors/plate/${id}/`)
            .then((response) => {
                return response.data;
            })
    },

    async fetchOptionsPlates(context, query = '') {
        return axios
            .options(`${serverUrl}/api/v1/actors/plate/${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async fetchOptionsPlatesId(context, query = '') {
        return axios
            .get(`${serverUrl}/api/v1/actors/plate/options_plate${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async fetchPriceGroup(context, query = '') {
        return axios
            .get(`${serverUrl}/api/v1/actors/price/${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async createPriceGroup(context, payload) {
        return axios
            .post(`${serverUrl}/api/v1/actors/price/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async updatePriceGroup(context, payload) {
        return axios
            .put(`${serverUrl}/api/v1/actors/price/${payload.id}/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async fetchOptionsPrices(context, query = '') {
        return axios
            .options(`${serverUrl}/api/v1/actors/price/${query}`)
            .then((response) => {
                return response.data;
            })
    },
}